import axios from "axios"
import { API_URL, APP_NAME } from "./api_urls"

// Epsilon API URL (for Epsilon invoice functions)
const EPSILON_API_URL = "https://be.devsoundfusion.com:10443"

async function loginAndGetRefreshToken() {
  try {
    const response = await axios.post(`${EPSILON_API_URL}/login`);
    const { jwt, jwtRefreshToken ,url1} = response.data;

    localStorage.setItem('jwt', jwt);
    localStorage.setItem('refreshtoken', jwtRefreshToken);
    localStorage.setItem('url1', url1);

    return jwt;
  } catch (error) {
    console.error('Login failed:', error.message);
    return null;
  }
}

// Refresh token
async function refreshToken() {
  const jwt = localStorage.getItem('jwt');
  const refreshToken = localStorage.getItem('refreshtoken');

  if (!refreshToken || !jwt) {
    console.log('No JWT in localStorage');
    return await loginAndGetRefreshToken();
  }

  const url = EPSILON_API_URL + "/refresh-token";
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  };

  const data = JSON.stringify({
    token: jwt,
    refreshToken: refreshToken,
  });

  const options = {
    method: 'POST',
    headers: headers,
    body: data,
  };

  try {
    const response = await fetch(url, options);
  
    // Check for HTTP errors
    // Use `response.json()` instead of `response.text()`
    const parsed = await response.json();
  
    if (response.status === 403) {
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('jwt');
      console.log('Refresh token invalid, redirecting to login');
      return await loginAndGetRefreshToken();
    }

    // Save new tokens and return the new JWT
    localStorage.setItem('jwt', parsed.jwt);
    localStorage.setItem('refreshtoken', parsed.jwtRefreshToken);
    return parsed.jwt;
  } catch (error) {
    console.error('Error refreshing token:', error.message);
    return null;
  }
}


async function getItems(order, customer) {
  const token = await refreshToken();
  const url =  localStorage.getItem('url1');
  console.log(url)
  if (!token) return;

  try {
    const response = await axios.get(`${EPSILON_API_URL}/get-items`, {
      params: {
        token: token // Add the token as a GET parameter
      }
    });

    return response.data;
  } catch (error) {
    console.error('Error Getting Items documents:', error.message);
  }
}
/**
 * Insert documents into Epsilon
 *
 * @param {Object} order - Order data
 * @param {Object} customer - Customer data
 * @param {Object} companyConfig - Optional company-specific Epsilon configuration
 * @param {string} companyConfig.epsilonUrl - Custom Epsilon API URL
 * @param {string} companyConfig.epsilonUsername - Epsilon username
 * @param {string} companyConfig.epsilonPassword - Epsilon password
 * @param {string} companyConfig.vatExemptionCode - VAT exemption code for EU transactions (e.g., "7")
 * @returns {Promise<Object>} - Response from Epsilon
 */
async function insertDocuments(order, customer, companyConfig = null) {
  // Determine API URL - use company-specific URL if provided
  const apiUrl = companyConfig?.epsilonUrl
    ? companyConfig.epsilonUrl.replace(/\/$/, '')
    : EPSILON_API_URL;

  let token;
  let url;

  // If company-specific credentials are provided, use them
  if (companyConfig?.epsilonUsername && companyConfig?.epsilonPassword) {
    try {
      // Login with company-specific credentials
      const loginResponse = await axios.post(`${apiUrl}/login`, {
        username: companyConfig.epsilonUsername,
        password: companyConfig.epsilonPassword,
      });

      token = loginResponse.data.jwt;
      url = loginResponse.data.url1;

      // Store temporarily for this session
      localStorage.setItem('jwt', token);
      localStorage.setItem('refreshtoken', loginResponse.data.jwtRefreshToken);
      localStorage.setItem('url1', url);
    } catch (loginError) {
      console.error('Company-specific Epsilon login failed:', loginError.message);
      throw new Error('Failed to authenticate with Epsilon using company credentials');
    }
  } else {
    // Use default/cached credentials
    token = await refreshToken();
    url = localStorage.getItem('url1');
  }

  if (!token) {
    throw new Error('No valid Epsilon token available');
  }

  try {
    const payload = {
      order,
      customer,
      token,
      url
    };

    // Add VAT exemption code if provided (for EU transactions)
    if (companyConfig?.vatExemptionCode) {
      payload.vatExemptionCode = companyConfig.vatExemptionCode;
    }

    const response = await axios.post(`${apiUrl}/insert-documents`, payload);

    return response.data;
  } catch (error) {
    console.error('Error inserting documents:', error.message);
    throw error;
  }
}

/**
 * Validate a Greek VAT number using the AADE service.
 * Uses the MyAade credentials configured in Settings.
 * Calls the new backend endpoint: POST /api/v2/flexflowdemo/vat/validate
 *
 * @param {string} vatNumber - The Greek VAT number (AFM) to validate
 * @returns {Promise<Object>} - Parsed response with company info from AADE
 * @throws {Error} - If validation fails or credentials are not configured
 */
const validateVAT = async (vatNumber) => {
  try {
    console.log("Validating VAT:", vatNumber)

    // Get session token for authentication
    const authUser = JSON.parse(localStorage.getItem("authUser"))
    const token = authUser?.session_token || ""

    const response = await axios.post(
      `${API_URL}${APP_NAME}vat/validate`,
      { vatNumber },
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: token ? `Bearer ${token}` : ""
        }
      }
    )

    return response.data
  } catch (error) {
    // Handle specific error cases
    if (error.response?.status === 403) {
      throw new Error("MyAade credentials not configured. Please configure them in Settings.")
    }
    if (error.response?.status === 401) {
      throw new Error("Authentication required. Please log in again.")
    }
    throw new Error(error.response?.data?.error || "Failed to validate VAT")
  }
}



export { getItems, validateVAT, loginAndGetRefreshToken, refreshToken, insertDocuments }


